import React from 'react';
import { Flag } from '@saleshandy/icons';

const MarkAsFinishedFlag = () => (
  <Flag width={16} height={16} className="blue-txt-11" />
);

export default MarkAsFinishedFlag;
